module.exports = __webpack_public_path__ + "static/media/mailbox.4eca9e82.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mailbox.png
// module id = 781
// module chunks = 0